import React from "react";
import { ComposedChart, Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { Panel, COLORS, ChartTooltipStyle } from "./ui";

const LABELS = { private: "פרטי", group: "קבוצתי", completed: "הושלמו", cancelled: "בוטלו" };

const LessonsTrendChart = ({ data, loading, error, onRetry }) => (
  <Panel
    eyebrow="שיעורים"
    title="מגמת שיעורים"
    subtitle="פרטי · קבוצתי · הושלמו · בוטלו, לפי חודש"
    accent="purple"
    loading={loading}
    error={error}
    onRetry={onRetry}
    empty={!loading && !error && (!data || data.length === 0)}
  >
    <div className="h-56 sm:h-64">
      <ResponsiveContainer width="100%" height="100%">
        <ComposedChart data={data} margin={{ top: 5, right: 5, left: -20, bottom: 0 }}>
          <CartesianGrid stroke={COLORS.grid} vertical={false} />
          <XAxis dataKey="period" tick={{ fontSize: 12, fill: "#6b7280" }} axisLine={false} tickLine={false} />
          <YAxis tick={{ fontSize: 12, fill: "#6b7280" }} axisLine={false} tickLine={false} />
          <Tooltip formatter={(val, name) => [val, LABELS[name] || name]} contentStyle={ChartTooltipStyle} />
          <Legend wrapperStyle={{ fontSize: 11 }} formatter={(v) => LABELS[v] || v} />
          <Bar dataKey="private" stackId="type" fill={COLORS.indigo} radius={[0, 0, 0, 0]} barSize={22} />
          <Bar dataKey="group" stackId="type" fill={COLORS.indigoSoft} radius={[6, 6, 0, 0]} barSize={22} fillOpacity={0.6} />
          <Line type="monotone" dataKey="completed" stroke={COLORS.emerald} strokeWidth={2.5} dot={{ r: 3 }} />
          <Line type="monotone" dataKey="cancelled" stroke={COLORS.rose} strokeWidth={2} strokeDasharray="4 3" dot={{ r: 2.5 }} />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  </Panel>
);

export default LessonsTrendChart;
